import get from "lodash/get";

interface ICallBack {
  (res: boolean): void
}

export function getUserConfirmation(dialogKey: string, callback: ICallBack) {
  const dialogTrigger = get(window, Symbol.for(dialogKey));

  if (dialogTrigger) {
    return dialogTrigger(callback);
  }

  callback(true);
}
